import useRerender from '@quicktools/shared-components/hooks/useRerender';
import { memo, useRef, useState } from 'react';

import Emoji from './Emoji';
import EmojisZeroResults from './EmojisZeroResults';
import useStyles from './styles';
import { IEmojis } from './types';

function Emojis({
  type = 'default',
  emojisList,
  displayCategory = true,
  stickyOffset,
  chooseEmoji,
  defaultDeviceType,
}: IEmojis) {
  const styles = useStyles();
  const hoveredNr = useRef(0);
  const [displayTooltip, setDisplayTooltip] = useState(true);
  const handleMouseEnter = () => {
    if (!displayTooltip) {
      return;
    }

    if (hoveredNr.current === 7) {
      setDisplayTooltip(false);
      return;
    }

    hoveredNr.current += 1;
  };

  useRerender();

  if (!displayCategory) {
    const emojisWithoutCategories = emojisList.map(({ emojis }) => emojis).flat(1);
    const displayZeroResults = emojisWithoutCategories.length === 0;

    if (displayZeroResults) {
      return <EmojisZeroResults />;
    }

    return (
      <ul className={styles.emojis}>
        {emojisWithoutCategories.map((emoji) => (
          <Emoji
            key={emoji.name}
            emoji={emoji}
            hover={handleMouseEnter}
            click={chooseEmoji}
            deviceType={type}
            displayTooltip={displayTooltip}
          />
        ))}
      </ul>
    );
  }

  return (
    <>
      {emojisList.map(({ emojis, category }) => (
        <div key={category} className={styles.container}>
          <div className={styles.category} style={{ top: stickyOffset - 8 }}>
            <span>{category}</span>
          </div>

          <ul className={styles.emojis}>
            {emojis
              .filter((emoji) => {
                return type === 'default' && emoji.missing?.includes(defaultDeviceType)
                  ? false
                  : !emoji.missing?.includes(type);
              })
              .map((emoji) => (
                <Emoji
                  key={emoji.name}
                  emoji={emoji}
                  hover={handleMouseEnter}
                  click={chooseEmoji}
                  deviceType={type}
                  displayTooltip={displayTooltip}
                />
              ))}
          </ul>
        </div>
      ))}
    </>
  );
}

export default memo(Emojis);
